import axios from "axios";
import { BACKEND_BASEURL } from "../../../db/baseUrl";
export const API_WAITER = `${BACKEND_BASEURL}api/waiters/`;

const createWaiter = async (waiterName) => {
  const response = await axios.post(API_WAITER + "createWaiter", {
    waiterName,
  });
  return response.data;
};
const getWaiters = async () => {
  const response = await axios.get(API_WAITER + "getWaiters");
  return response.data;
};

const updateWaiter = async ({ waiterName, waiterId }) => {
  console.log(`${API_WAITER}updateWaiter/${waiterId}`);
  const response = await axios.patch(`${API_WAITER}updateWaiter/${waiterId}`, {
    waiterName,
  });
  return response.data;
};
const deleteWaiter = async (waiterId) => {
  const response = await axios.delete(`${API_WAITER}deleteWaiter/${waiterId}`);
  return response.message;
};

const WaiterServices = {
  createWaiter,
  getWaiters,
  deleteWaiter,
  updateWaiter,
};
export default WaiterServices;
